import { ChangeDetectionStrategy, Component, forwardRef, OnInit } from "@angular/core"
import { ControlValueAccessor, FormBuilder, FormControl, NG_VALUE_ACCESSOR } from "@angular/forms"

@Component({
    selector: "app-account-info",
    templateUrl: "./account-info.component.html",
    styleUrls: ["./account-info.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AccountInfoComponent),
            multi: true,
        },
    ],
    standalone: false,
})
export class AccountInfoComponent implements ControlValueAccessor, OnInit {
    accountInfo = this.fb.group({
        email: [""],
        password: [""],
        isPBSAccountLogin: [false],
        publicMediaProfileLink: [null],
    })

    constructor(private fb: FormBuilder) {}

    ngOnInit() {
        this.accountInfo.disable()
    }

    writeValue(value: {
        email: string
        password: string
        isPBSAccountLogin: boolean
        publicMediaProfileLink: string | null
    }): void {
        this.accountInfo.patchValue(value)
    }

    get isPBSAccountLogin() {
        let isPBSAccountLogin = this.accountInfo.get("isPBSAccountLogin") as FormControl
        return !!isPBSAccountLogin.value
    }

    get publicMediaProfileLink() {
        let publicMediaProfileLink = this.accountInfo.get("publicMediaProfileLink") as FormControl
        return publicMediaProfileLink.value
    }

    registerOnChange(fn: any): void {
        this.accountInfo.valueChanges.subscribe(fn)
    }

    registerOnTouched(fn: any): void {}

    setDisabledState(isDisabled: boolean): void {
        if (isDisabled) {
            return this.accountInfo.disable()
        }
        //this will enable the email and pass fields, for the moment those fields should not be editable
        // this.accountInfo.enable()
    }
}
